import React from "react";
import css from "@styled-system/css";
import styled from "styled-components";
import ReactSelect from "react-select";
import AsyncSelect from "react-select/async";

import { Box, Text, Error, Warning, IconOption } from "atoms";

import { theme } from "styles";

import MemoChevronDownSharp from "assets/icons/ChevronDownSharp";

export const SelectFieldBase = styled(Box)`
  position: relative;
  width: 100%;
  display: grid;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-family: "NeometricRegular";

  label {
    background-color: ${(props) => props.theme.colors.white};
    font-size: 14px;
    ${() =>
      css({
        borderRadius: "8px",
        fontFamily: "NeometricRegular",
        span: {
          position: "absolute",
          top: "50%",
          left: "0px",
          transform: "translateY(-50%)",
          transition: "0.2s all",
        },

        // ...(!labelHide && {
        //   input: {
        //     "::placeholder": {
        //       opacity: 0,
        //       visibility: "hidden",
        //     },
        //     "&:focus + span, &:not(:placeholder-shown) + span": {
        //       top: "0px",
        //       fontSize: "14px",
        //     },
        //   },
        // }),
      })}
  }
`;

// const { ValueContainer, Placeholder, Option } = components;

// const CustomValueContainer = ({ children, isFocused, selectProps, ...props }) => (
//   <ValueContainer isFocused={isFocused} {...selectProps} {...props}>
//     <Placeholder isFocused={isFocused} {...selectProps} {...props}>
//       {selectProps.placeholder && !selectProps.inputValue && (
//         <Text color="neutral.500" fontSize="1.6rem">
//           {selectProps?.placeholder}
//         </Text>
//       )}
//     </Placeholder>
//     {React.Children.map(children, (child) => (child && child.type !== Placeholder ? child : null))}
//   </ValueContainer>
// );

// const DropdownIndicator = ({ ...props }) => {
//   return (
//     <components.DropdownIndicator {...props}>
//       <Box transform="rotate(180deg)" color="neutral.500">
//         <MemoSelectArrowUpIcon />
//       </Box>
//     </components.DropdownIndicator>
//   );
// };

// const IconOption = ({ ...props }) => (
//   <Option {...props}>
//     <Flex aI="center" jC="space-between">
//       {props.data.label}
//       <Box mr="3.2rem">
//         <Box as="custom-select-icon">
//           <MemoPointerIcon />
//         </Box>
//       </Box>
//     </Flex>
//   </Option>
// );

export const SelectField = ({
  label,
  placeholder,
  error,
  width,
  warning,
  isMulti,
  noMargin,
  labelHide,
  searchable,
  searchableblue,
  Icon,
  borderRadius,
  styles,
  isOptionLoadAsync,
  controlProps,
  ...props
}) => (
  <SelectFieldBase margin={noMargin ? "0 !important" : undefined}>
    <Text as="label" color="gray.700" fontSize={7}>
      {isOptionLoadAsync ? (
        <AsyncSelect
          placeholder={placeholder}
          isSearchable={true}
          components={{
            // ValueContainer: CustomValueContainer,
            DropdownIndicator: (state) => (
              <Box
                color={state.isFocused ? "neutral.700" : "neutral.300"}
                mr="10px"
              >
                {state.selectProps.menuIsOpen ? (
                  <Box transform="rotate(180deg)">
                    <MemoChevronDownSharp height=".7rem" />
                  </Box>
                ) : (
                  <MemoChevronDownSharp height=".7rem" />
                )}
              </Box>
            ),
            Option: IconOption,
          }}
          styles={{
            control: (provided, state) => ({
              ...provided,
              // borderColor: theme.colors?.neutral[300],
              boxShadow: "none",
              flexWrap: "nowrap",
              cursor: "pointer",
              padding: "13px 16px",
              borderRadius: "1rem",
              maxHeight: "50px",
              ...(Icon && {
                paddingLeft: "2rem",
              }),
              backgroundColor: state?.isDisabled ? "#fafafa" : "inherit",
              "&:hover": {
                borderColor: "#000000",
              },
              "&:focus, &:active, &:focus-within": {
                borderColor: "#006C11",
              },
              borderColor: error
                ? theme.colors.accents[100]
                : theme.colors?.neutral[200],
              ...controlProps,
            }),
            valueContainer: (provided) => ({
              ...provided,
              padding: "0px",
              fontFamily: "NeometricRegular",
              fontSize: "1.8rem",
              width: width || provided?.width,
            }),
            placeholder: (provided, state) => ({
              ...provided,
              position: "absolute",
              fontFamily: "NeometricRegular",
              top:
                state?.hasValue || state?.selectProps?.inputValue
                  ? "-6px"
                  : "40%",
              transition: "top 0.1s, font-size 0.1s",
              fontSize: "1.6rem",
              lineHeight: "4px",
              backgroundColor:
                (state?.hasValue || state?.selectProps?.inputValue) && "white",
              color: theme.colors?.neutral[500],
              whiteSpace: "nowrap",
              display:
                state?.hasValue && labelHide ? "none" : provided?.display,
            }),
            loadingIndicator: (provided) => ({
              ...provided,
              position: "relative",
            }),
            dropdownIndicator: (provided) => ({
              ...provided,
              padding: 0,
            }),
            singleValue: (provided, state) => ({
              ...provided,
              color: state?.isDisabled ? "#C4C4C4" : "inherit",
            }),
            // multiValue: (provided) => ({
            //   ...provided,
            //   backgroundColor: theme.colors.blue[400],
            //   alignItems: "center",
            //   height: "26px",
            //   paddingRight: "2px",
            //   marginTop: "1px",
            // }),
            // multiValueLabel: (provided) => ({
            //   ...provided,
            //   color: "white",
            //   paddingBottom: "1px",
            // }),
            option: (provided, state) => ({
              ...provided,
              backgroundColor: "white",
              fontSize: "1.6rem",
              fontWeight: "400",
              borderRadius: "4px",
              fontFamily: "NeometricRegular",
              color: state?.isSelected
                ? theme.colors?.secondary[700]
                : theme.colors?.neutral[700],
              "&:hover": {
                backgroundColor: "white",
                color: theme.colors?.secondary[700],
              },
              "& custom-select-icon": {
                display: "none",
              },
              "&:hover custom-select-icon": {
                display: "block",
              },
            }),
            // multiValueRemove: (base, state) =>
            //   state?.data.isFixed
            //     ? { ...base, display: "none" }
            //     : {
            //         ...base,
            //         color: "white",
            //         backgroundColor: theme.colors.red[500],
            //         borderRadius: "10px",
            //         width: "20px",
            //         height: "20px",
            //       },
            menu: (provided) => ({
              ...provided,
              ...styles?.menu,
              animation: "fadeIn 0.4s ease-in-out",
              borderRadius: "8px",
              boxShadow: "0px 10px 40px rgba(0, 0, 0, 0.08)",
              paddingLeft: "8px",
              paddingRight: "16px",
            }),
            menuList: (provided) => ({
              ...provided,

              "::-webkit-scrollbar": {
                width: "3px",
                height: "0px",
              },
              "::-webkit-scrollbar-track": {
                background: "#fff",
              },
              "::-webkit-scrollbar-thumb": {
                background: "#D9D9D9",
                borderRadius: "7px",
              },
            }),
            menuPortal: (provided) => ({
              ...provided,
              zIndex: 8000,
            }),
          }}
          closeMenuOnSelect={!isMulti}
          tabSelectsValue={false}
          isMulti={isMulti}
          menuPortalTarget={document.body}
          {...props}
        />
      ) : (
        <ReactSelect
          placeholder={placeholder}
          isSearchable={false}
          components={{
            // ValueContainer: CustomValueContainer,
            DropdownIndicator: (state) => (
              <Box
                color={state.isFocused ? "neutral.700" : "neutral.300"}
                mr="10px"
              >
                {state.selectProps.menuIsOpen ? (
                  <Box transform="rotate(180deg)">
                    <MemoChevronDownSharp height=".7rem" />
                  </Box>
                ) : (
                  <MemoChevronDownSharp height=".7rem" />
                )}
              </Box>
            ),
            Option: IconOption,
          }}
          styles={{
            control: (provided, state) => ({
              ...provided,
              // borderColor: theme.colors?.neutral[300],
              boxShadow: "none",
              flexWrap: "nowrap",
              cursor: "pointer",
              padding: "13px 16px",
              borderRadius: "1rem",
              // maxHeight: "50px",
              ...(!isMulti && { maxHeight: "50px" }),
              ...(Icon && {
                paddingLeft: "2rem",
              }),
              backgroundColor: state?.isDisabled ? "#fafafa" : "inherit",
              "&:hover": {
                borderColor: "#000000",
              },
              "&:focus, &:active, &:focus-within": {
                borderColor: "#006C11",
              },
              borderColor: error
                ? theme.colors.accents[100]
                : theme.colors?.neutral[200],
              ...controlProps,
            }),
            valueContainer: (provided) => ({
              ...provided,
              padding: "0px",
              fontFamily: "NeometricRegular",
              fontSize: "1.8rem",
              width: width || provided?.width,
            }),
            placeholder: (provided, state) => ({
              ...provided,
              position: "absolute",
              fontFamily: "NeometricRegular",
              top:
                state?.hasValue || state?.selectProps?.inputValue
                  ? "-6px"
                  : "40%",
              transition: "top 0.1s, font-size 0.1s",
              fontSize: "1.6rem",
              lineHeight: "4px",
              backgroundColor:
                (state?.hasValue || state?.selectProps?.inputValue) && "white",
              color: theme.colors?.neutral[500],
              whiteSpace: "nowrap",
              display:
                state?.hasValue && labelHide ? "none" : provided?.display,
            }),
            loadingIndicator: (provided) => ({
              ...provided,
              position: "relative",
            }),
            dropdownIndicator: (provided) => ({
              ...provided,
              padding: 0,
            }),
            singleValue: (provided, state) => ({
              ...provided,
              color: state?.isDisabled ? "#C4C4C4" : "inherit",
            }),
            // multiValue: (provided) => ({
            //   ...provided,
            //   backgroundColor: theme.colors.blue[400],
            //   alignItems: "center",
            //   height: "26px",
            //   paddingRight: "2px",
            //   marginTop: "1px",
            // }),
            // multiValueLabel: (provided) => ({
            //   ...provided,
            //   color: "white",
            //   paddingBottom: "1px",
            // }),
            option: (provided, state) => ({
              ...provided,
              backgroundColor: "white",
              fontSize: "1.6rem",
              fontWeight: "400",
              borderRadius: "4px",
              fontFamily: "NeometricRegular",
              color: state?.isSelected
                ? theme.colors?.secondary[700]
                : theme.colors?.neutral[700],
              "&:hover": {
                backgroundColor: "white",
                color: theme.colors?.secondary[700],
              },
              "& custom-select-icon": {
                display: "none",
              },
              "&:hover custom-select-icon": {
                display: "block",
              },
            }),
            // multiValueRemove: (base, state) =>
            //   state?.data.isFixed
            //     ? { ...base, display: "none" }
            //     : {
            //         ...base,
            //         color: "white",
            //         backgroundColor: theme.colors.red[500],
            //         borderRadius: "10px",
            //         width: "20px",
            //         height: "20px",
            //       },
            menu: (provided) => ({
              ...provided,
              ...styles?.menu,
              animation: "fadeIn 0.4s ease-in-out",
              borderRadius: "8px",
              boxShadow: "0px 10px 40px rgba(0, 0, 0, 0.08)",
              paddingLeft: "8px",
              paddingRight: "16px",
            }),
            menuList: (provided) => ({
              ...provided,

              "::-webkit-scrollbar": {
                width: "3px",
                height: "0px",
              },
              "::-webkit-scrollbar-track": {
                background: "#fff",
              },
              "::-webkit-scrollbar-thumb": {
                background: "#D9D9D9",
                borderRadius: "7px",
              },
            }),
            menuPortal: (provided) => ({
              ...provided,
              zIndex: 8000,
            }),
          }}
          closeMenuOnSelect={!isMulti}
          tabSelectsValue={false}
          isMulti={isMulti}
          menuPortalTarget={document.body}
          {...props}
        />
      )}

      {Icon && (
        <Box position="absolute" top="12px" left="11px" color="blue.400">
          <Icon />
        </Box>
      )}
    </Text>
    {error && (
      <Box position="absolute" bottom="0" width="inherit">
        <Error text={error} />
      </Box>
    )}

    {warning && <Warning text={warning} />}
  </SelectFieldBase>
);
